import Layout from './components/Layout';
import Nav from './components/Nav';

import Home from './pages/Home';

function App() {
  return (
    <div>
      <Layout>
        <Home />
      </Layout>
    </div>
  );
}

export default App;
